var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$agentIsScannerReady)?_c('div',{staticClass:"button is-info",on:{"click":()=>_vm.scan()}},[_c('i',{staticClass:"mdi mdi-scanner mdi-24px"}),_vm._v(" Scan ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }